import { ServiceRequestStatusEnum } from 'lane-shared/domains/workOrder/constants';

/**
 * Converts a string status to ServiceRequestStatusEnum
 * @param status - The string status to convert
 * @returns The ServiceRequestStatusEnum value or undefined if invalid
 */
export function getServiceRequestStatusEnum(
  status?: string | null
): ServiceRequestStatusEnum | undefined {
  if (!status) return undefined;

  // Type-safe check using Object.values and type assertion only after validation
  const validStatuses = Object.values(ServiceRequestStatusEnum);

  if (validStatuses.includes(status as ServiceRequestStatusEnum)) {
    // Only cast after we've verified it's a valid value
    return status as ServiceRequestStatusEnum;
  }

  return undefined;
}
